const colors = {
  // primary: '#7753F8',
  // secondary: 'rgba(119, 83, 248, 0.6)',

  primary: '#22C0E7',
  secondary: 'rgba( 34, 192, 231, 0.6)',

  primaryShades: ['#E8FAFF', 'rgb(34, 192, 231 , 0.8)'],
  transparent: 'transparent',
  orange: '#FE8400',
  orangeShades: ['#fff8d1', '#ffecda'],
  darkOrange: '#f37217',
  green: '#7CD420',
  greenShades: ['#defeeb'],
  darkGreen: '#55b32f',
  red: '#ec5050',
  darkRed: '#ce4444',
  pinkishResd: '#F2335D',
  blue: '#418CC9',
  darkBlue: '#1a7bcb',
  lightBlue: '#12A5EC',
  lightGray: '#f9f7ff',
  gray: '#E5E5E5',
  grayShades: ['#787575', '#333131', '#312f2f'],
  darkGray: '#999595',
  geryBgShade: '#F2F1F3',
  white: '#FFFFFF',
  black: '#261B50',
  lightBlack: '#605D70',
  blackBG: '#2C2633',
  yellow: '#FFCC00',
  purpleDark: '#1E1640',
  purpleLight: '#F3EFFF',
  blackShades: ['#605D70', '#2C2633', '#7d7694'],
  secondaryShades: ['#E8FAFF'],
  purpleShades: ['rgba(119, 83, 248, 0.4)', 'rgba(119, 83, 248, 0.15)'],
  blueShades: ['rgba(34, 192, 231, 0.4)', 'rgba(34, 192, 231, 0.15)'],
  toolbar: '#EFEBFE',
  border: '#EEEAFD',
  title: 'rgba(38, 27, 80, 0.7)',
  primaryDark: '#21053C',
  goldDark: '#C4A968',
  gold: '#FFEFBD',

  gradients: {
    gold: `linear-gradient(90deg, #C4A968 -0.11%, #FFEFBD 101.4%)`,
    silver: `linear-gradient(180deg, #FFFFFF 0%, #B1B1B1 100%)`,
    bronze: `linear-gradient(155.47deg, #F9BE89 36.19%, #FFE3CD 50.69%, #BC764B 67.83%)`,
    platinum: `linear-gradient(108.86deg, #86AAB9 9.55%, #EAEEF0 45.19%, #E7F9F5 87.32%)`,
  },

  // for dark mode
  darkBG: '#202124',
  sectionBG: '#36373a',
  darkText: '#F5F5F7',
  // for light mode
  // lightBG: '#f9f8ff',
  lightText: '#2E0509',

  lightBG: '#FDFDFD',

  themeLightBlue: '#22C0E7',
  themeBgLightBlue: '#E8FAFF',
};

export default colors;
